<template>
  <div class="cardsharenotenews">
    <div class="card bg-primary mb-4" style="display:none;">
      <div class="card-header">
        <h4 class="mb-0">
          <router-link to="/category/sharenote-news/1" class="text-light"><span class="d-none d-lg-block"><i class="far fa-newspaper fa-fw mr-2"></i>ShareNote.com News</span><span class="d-sm-block d-lg-none"><i class="far fa-newspaper fa-fw mr-2"></i>News</span></router-link>
        </h4>
      </div>
      <ul class="list-group list-group-flush">
        <li class="list-group-item" v-for="post in posts">
          <router-link :to="{ name: 'post', params: { slug: post.slug }}" v-html="post.title.rendered">{{ post.title.rendered }}</router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      posts: [],
      errors: []
    }
  },
  created() {
    axios.get(`https://wpapi.sharenote.com/wp-json/wp/v2/posts?per_page=3&categories=1`)
    .then(response => {
      this.posts = response.data
    })
    .catch(e => {
      this.errors.push(e)
    })
  }
}
</script>
